import type { ReactNode } from 'react';

export interface BannerProps {
  kind: 'danger' | 'warn' | 'ok';
  children: ReactNode;
}

export function Banner({ kind, children }: BannerProps) {
  return (
    <div className={`banner banner--${kind}`} role={kind === 'danger' ? 'alert' : 'status'}>
      {children}
    </div>
  );
}
